import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Logo_A from "../Assets/client_logo/clientS1 copy.png";
import Logo_B from "../Assets/client_logo/clientP9.png";
import Logo_C from "../Assets/client_logo/bank.png";
import Logo_D from "../Assets/client_logo/PetKraft.png";
import Logo_E from "../Assets/client_logo/clientT1.png";
import Logo_F from "../Assets/client_logo/clientT2.png";
import Logo_G from "../Assets/client_logo/clientP8.png";
import Logo_H from "../Assets/client_logo/clientP1.png";
import Logo_I from "../Assets/client_logo/clientS2 copy.png";
import Logo_J from "../Assets/client_logo/clientP2.png";
import Logo_K from "../Assets/client_logo/clientP3.png";
import Logo_L from "../Assets/client_logo/clientS3 copy.png";
import Logo_M from "../Assets/client_logo/clientP4.png";
import Logo_N from "../Assets/client_logo/clientS4.png";
import Logo_O from "../Assets/client_logo/clientS5 copy.png";
import Logo_P from "../Assets/client_logo/clientP5.png";
import Logo_Q from "../Assets/client_logo/clientS6.png";
import Logo_R from "../Assets/client_logo/clientP6.png";
import Logo_S from "../Assets/client_logo/clientS7.png";
import Logo_T from "../Assets/client_logo/KPS.jpg";
import Logo_U from "../Assets/client_logo/MLZSUnnao.jpg";
import '../CSS/SlickCarousel.css'

export default function Client() {
  const images = [
    { srNo: 1, title: "Client A", Url: Logo_A },
    { srNo: 2, title: "Client B", Url: Logo_B },
    { srNo: 3, title: "Client C", Url: Logo_C },
    { srNo: 4, title: "Client D", Url: Logo_D },
    { srNo: 5, title: "Client E", Url: Logo_E },
    { srNo: 6, title: "Client F", Url: Logo_F },
    { srNo: 7, title: "Client G", Url: Logo_G },
    { srNo: 8, title: "Client H", Url: Logo_H },
    { srNo: 9, title: "Client I", Url: Logo_I },
    { srNo: 10, title: "Client J", Url: Logo_J },
    { srNo: 11, title: "Client K", Url: Logo_K },
    { srNo: 12, title: "Client L", Url: Logo_L },
    { srNo: 13, title: "Client M", Url: Logo_M },
    { srNo: 14, title: "Client N", Url: Logo_N },
    { srNo: 15, title: "Client O", Url: Logo_O },
    { srNo: 16, title: "Client P", Url: Logo_P },
    { srNo: 17, title: "Client Q", Url: Logo_Q },
    { srNo: 18, title: "Client R", Url: Logo_R },
    { srNo: 19, title: "Client S", Url: Logo_S },
    { srNo: 20, title: "Client T", Url: Logo_T },
    { srNo: 21, title: "Client U", Url: Logo_U },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 2,
    autoplay: true,
    draggable: true,
    responsive: [
      {
        breakpoint: 1200, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 3, // Display 1 image per slide on smaller screens
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 668,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <section id="client" className="client py-5">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>Clients</h2>
            <h3>Our <span>Clients</span></h3>
          </div>
        </div>
        <div className="wrapper container">
          <Slider {...settings} className="image-slider">
            {images.map((image, index) => (
              <div key={index} className="slick-slide">
                <img src={image.Url} alt={image.title} className='img1' />
              </div>
            ))}
          </Slider>
        </div>
      </section>
    </>
  );
}
